export function formatSystemPhone(diallingCode?: string, phoneNumber?: string) {
  if (!diallingCode || !phoneNumber) {
    return '';
  }

  return `${diallingCode}${phoneNumber}`;
}
